// Hijri (Islamic) calendar months reference
export interface HijriMonth {
  index: number; // 1..12
  en: string;
  bn: string;
  arabic: string;
  significance: { en: string; bn: string };
}

export const HIJRI_MONTHS: HijriMonth[] = [
  { index: 1, en: "Muharram", bn: "মুহাররম", arabic: "محرّم",
    significance: { en: "First month of the Islamic year. One of the four sacred months. Day of Ashura (10th) is observed by fasting.", bn: "ইসলামি বছরের প্রথম মাস। চারটি সম্মানিত মাসের একটি। ১০ তারিখ আশুরা — রোজা পালিত হয়।" } },
  { index: 2, en: "Safar", bn: "সফর", arabic: "صفر",
    significance: { en: "Second month. No major fixed observance.", bn: "দ্বিতীয় মাস। কোনো বড় নির্দিষ্ট পালনীয় নেই।" } },
  { index: 3, en: "Rabi' al-Awwal", bn: "রবিউল আউয়াল", arabic: "ربيع الأول",
    significance: { en: "Eid-e-Miladunnabi (12th) — the Prophet Muhammad's (PBUH) birthday is observed.", bn: "১২ তারিখ ঈদে মিলাদুন্নবী — মহানবী (সা.)-এর জন্মদিন।" } },
  { index: 4, en: "Rabi' al-Thani", bn: "রবিউস সানি", arabic: "ربيع الآخر",
    significance: { en: "Fourth month, also called Rabi' al-Akhir.", bn: "চতুর্থ মাস, রবিউল আখিরও বলা হয়।" } },
  { index: 5, en: "Jumada al-Awwal", bn: "জমাদিউল আউয়াল", arabic: "جمادى الأولى",
    significance: { en: "Fifth month.", bn: "পঞ্চম মাস।" } },
  { index: 6, en: "Jumada al-Thani", bn: "জমাদিউস সানি", arabic: "جمادى الآخرة",
    significance: { en: "Sixth month, also called Jumada al-Akhirah.", bn: "ষষ্ঠ মাস, জমাদিউল আখিরাও বলা হয়।" } },
  { index: 7, en: "Rajab", bn: "রজব", arabic: "رجب",
    significance: { en: "One of the four sacred months. Lailat al-Mi'raj (Shab-e-Mi'raj) is observed on the 27th.", bn: "চারটি সম্মানিত মাসের একটি। ২৭ তারিখ শবে মিরাজ পালিত হয়।" } },
  { index: 8, en: "Sha'ban", bn: "শাবান", arabic: "شعبان",
    significance: { en: "Shab-e-Barat (Lailat al-Bara'ah) is observed on the 15th. Preparation for Ramadan.", bn: "১৫ তারিখ শবে বরাত। রমজানের প্রস্তুতির মাস।" } },
  { index: 9, en: "Ramadan", bn: "রমজান", arabic: "رمضان",
    significance: { en: "Month of fasting (Sawm) — the third pillar of Islam. Lailat al-Qadr is in the last 10 nights.", bn: "রোজার মাস — ইসলামের তৃতীয় স্তম্ভ। শেষ দশকে লাইলাতুল কদর।" } },
  { index: 10, en: "Shawwal", bn: "শাওয়াল", arabic: "شوّال",
    significance: { en: "Eid-ul-Fitr is on the 1st of Shawwal — celebrating the end of Ramadan fasting.", bn: "১ তারিখ ঈদুল ফিতর — রমজানের রোজা শেষের উৎসব।" } },
  { index: 11, en: "Dhu al-Qi'dah", bn: "জিলকদ", arabic: "ذو القعدة",
    significance: { en: "One of the four sacred months. Hajj travel season begins.", bn: "চারটি সম্মানিত মাসের একটি। হজের যাত্রার মাস।" } },
  { index: 12, en: "Dhu al-Hijjah", bn: "জিলহজ", arabic: "ذو الحجة",
    significance: { en: "Hajj is performed in the first 10 days. Eid-ul-Adha is on the 10th. One of the four sacred months.", bn: "প্রথম ১০ দিনে হজ পালিত হয়। ১০ তারিখ ঈদুল আজহা। চারটি সম্মানিত মাসের একটি।" } },
];
